import '@/assets/scss/global.scss';

// UI
export { default as BaseButton } from '@/components/Ui/Buttons';
export { default as FileUpload } from './components/Forms/FileUpload/FileUpload.vue';
// Inputs
export {
  TextInput, DateInput, DateGroup, TextAreaInput, NumberInput, SecureInput, SearchInput,
} from './components/Forms/Inputs';
export { default as SkeletonLoader } from '@/components/Ui/SkeletonLoader/SkeletonLoader.vue';

// forms
export { default as Radio } from './components/Forms/Radio/Radio.vue';
export { default as DropdownSelect } from './components/Forms/Dropdown/DropdownSelect.vue';
export { default as Checkbox } from './components/Forms/Checkbox/Checkbox.vue';
export { default as SwitchInput } from './components/Forms/Switch/Switch.vue';

// modal
export { default as Modal } from '@/components/Ui/Modal/Modal.vue';

// TABLE
export { default as TableMain } from './components/tables/TablesMain/TablesMain.vue';

export { default as TableData } from './components/tables/Main';
// Navigation
export { default as HorizontalNavigation } from './components/Navigation/HorizontalNavigation/HorizontalNav.vue';

// Charts
export { default as LineGraph } from './components/charts/LineGraph/LineGraph.vue';
export { default as ProgressChart } from './components/charts/ProgressChart/ProgressChart.vue';
